<template>
    <div class="wrapper">
        <!-- <div class="banner">
            <a href="javascript:void(0);" @click="showBigDialog">
                <img src="../../assets/images/callback/product-adv.png" alt="">
            </a>
        </div>          -->
        <div class="orders">
            <div class="orders-list">
                <div class="orders-nav">
                    <div class="order-nav-element" :class="{ 'active': navStatus == 1 }" @click="process">
                        <a href="javascript:void(0);">Processing</a>
                    </div>
                    <div class="order-nav-element" :class="{ 'active': navStatus == 2 }" @click="finished">
                        <a href="javascript:void(0);">Finished</a>
                    </div>
                </div>
            </div>
            <div class="orders-wrapper">
                <div class="no-order" v-show='status == 0'>
                    <div class="banner"></div>
                    <h2 class="title">
                        Loan History
                    </h2>
                    <p class="caption">
                        No order history go get your first loan
                    </p>
                    <div class="btn-container">
                        <router-link class="btn-submit" to="/">Apply</router-link>
                    </div>
                </div>
                <div v-show='status == 1'>
                    <div class="orders-list">
                        <div class="order-wrapper">
                            <div class="order-element" v-for="(element, ind) in active_list_computed" :key="ind"
                                :class="{ 'valid': ['1', '2', '6', '8', '11'].indexOf(element.orderState) != -1, 'invalid': ['3', '4', '5', '7', '9'].indexOf(element.orderState) != -1 }">
                                <div class="tag"
                                    :class="{ 'valid': ['1', '2', '6', '8', '11'].indexOf(element.orderState) != -1, 'invalid': ['3', '4', '5', '7', '9'].indexOf(element.orderState) != -1 }">
                                    <span class="order_state" v-text="getStateText(element.orderState)"></span>
                                </div>
                                <div class="order-id" v-text="` ${element.productName}`"></div>
                                <ul class="order-info-list">
                                    <li class="oi-element">
                                        <span class="left">Order No</span>
                                        <span class="right" v-text="`${element.orderNo}`"></span>
                                    </li>
                                    <li class="oi-element">
                                        <span class="left">Loan Amount</span>
                                        <span class="right" v-text="`₹ ${element.loanAmount}`"></span>
                                    </li>
                                    <!-- <li class="oi-element">
                                        <span class="left">Tenure</span>
                                        <span class="right" v-text="`${element.period} days`"></span>
                                    </li> -->
                                    <li class="oi-element">
                                        <span class="left">Received</span>
                                        <span class="right" v-text="`₹ ${element.arriveAmount}`"></span>
                                    </li>
                                    <li class="oi-element">
                                        <span class="left">Repayment Amount</span>
                                        <span class="right" v-text="`₹ ${element.repaymentAmount}`"></span>
                                    </li>
                                </ul>
                                <router-link v-show="element.url != ''" class='wrapper-link'
                                    :to="`${element.url}`"></router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { reactive, onMounted, ref, computed} from 'vue'
import { getOrders, getFinishOrders } from '@api/index'
import { useLoading } from 'vue-loading-overlay'
export default {
    setup() {        
        const navStatus = ref(1)
        const dict = {
            "1": "Auditing",
            "2": "Pass",
            "3": "Denied",
            "4": "Lending",
            "5": "Failed",
            "6": "Loaned",
            "7": "Settled",
            "8": "Overdued",
            "11": "Extension"
        }
        const orders = reactive({
            list: []
        })
        let bigDialogState = ref(false)
        const closeBigDialog = () => {
            bigDialogState.value = false
        }
        const showBigDialog = () => {
            bigDialogState.value = true
        }
        const active_list_computed = computed(()=>{
            let list = []
            if(navStatus.value == 1) {
                list = orders.list
            }
            if(navStatus.value == 2) {
                list = orders.list2
            }            
            return list
            
        })
        const status = computed(()=>{
            if(active_list_computed.value.length == 0) {
                return 0
            }
            return 1
        })
        const dealRow = (element) => {
            if (['1'].indexOf(element.orderState) != -1) {
                element.url = `/orders/${element.orderId}/audit`
            } else if (element.orderState == '2') {
                element.url = `/orders/${element.orderId}/confirm`
            } else if (element.orderState == '6' || element.orderState == '8' || element.extensionState == '3') {
                element.url = `/orders/${element.orderId}/detail`
            } else if (element.extensionState == '2' || element.orderState == '11') {
                element.url = `/orders/${element.orderId}/extension`
            } else {
                element.url = ''
            }
            return element
        }
        const loading = useLoading()
        onMounted(() => {
            const loader = loading.show({
                container: null
            })
            getOrders().then((res) => {
                loader.hide()
                if (res.code == 0) {
                    orders.list = res.data.map((element) => {
                        return dealRow(element)
                    })
                    if (orders.list.length) {
                        status.value = 1
                    } else {
                        status.value = 0
                    }
                }
            })
            // loader.show()
            getFinishOrders().then((res) => {
                loader.hide()
                if (res.code == 0) {
                    orders.list2 = res.data.map((element) => {
                        return dealRow(element)
                    })
                    if (orders.list.length) {
                        status.value = 1
                    } else {
                        status.value = 0
                    }
                }
            })
        })
        const getStateText = (state) => {
            return dict[state]
        }
        const process = () => {
            navStatus.value = 1
        }
        const finished = () => {
            navStatus.value = 2
        }
        return {
            orders,
            getStateText,
            status,
            closeBigDialog,
            showBigDialog,
            bigDialogState,
            navStatus,
            process,
            finished,
            active_list_computed
        }
    }
}
</script>
<style lang="less" scoped>
div.orders-list {    
    div.orders-nav {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin-bottom: 30px;               
        div.order-nav-element {
            width: 355px;
            height: 90px;
            line-height: 90px;
            border:1px solid #000;             
            &:first-child {
                border-right: none;
            }

            &.active {
                background:#189A63;
                a {
                    color: #fff;
                    font-weight: 700;
                }

            }

            a {
                display: block;
                font-size: 36px;
                text-align: center;
                color: #333;
            }
        }
    }
}

.banner {
    width: 654px;
    height: 100px;
    margin: 0 auto 50px auto;

    a {
        display: block;
        border-radius: 20px;
        overflow: hidden;

        img {
            width: 100%;
            height: 100%;
        }
    }
}

.big-dialog-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: RGBA(255, 50, 163, 1);
    background-size: 100% 100%;
    overflow: auto;
    z-index: 999;

    div.big-dialog-inner {
        width: 100%;
        min-height: 1509px;
        background: url("../../assets/images/callback/dbg.png") no-repeat;
        background-size: contain;
        position: absolute;
        top: 0;
        left: 0;
        padding-bottom: 50px;
    }

    .icon-close {
        position: absolute;
        top: 40px;
        right: 40px;
    }

    .big-dialog {
        background: #fff;
        width: 616px;
        // height: 876px;
        padding: 25px 35px;
        margin: 220px auto 0 auto;
        border-radius: 20px;

        .bec-element {
            line-height: 1.5;

            .left {
                color: #333;
                font-size: 28px;
                font-weight: 700;
            }

            .right {
                color: #333;
                font-size: 28px;
            }
        }

        .big-element {
            margin-bottom: 50px;

            &.cooper {
                .be-content {
                    background: rgba(250, 177, 140, 0.15);
                    padding: 20px;
                    width: 566px;
                    margin-top: 30px;
                    border-radius: 20px;

                    .bec-element {
                        &::nth-child(2) {
                            .right {
                                color: rgba(233, 144, 107, 1)
                            }
                        }
                    }
                }

            }

            &.siliver {
                .be-content {
                    background: RGBA(248, 249, 255, 1);
                    padding: 20px;
                    width: 566px;

                    .bec-element {
                        &::nth-child(2) {
                            .right {
                                color: RGBA(125, 133, 198, 1)
                            }
                        }
                    }
                }

            }

            &.gold {
                .be-content {
                    background: RGBA(255, 248, 238, 1);
                    padding: 20px;
                    width: 566px;

                    .bec-element {
                        &::nth-child(2) {
                            .right {
                                color: RGBA(241, 138, 25, 1)
                            }
                        }
                    }
                }

            }

            .be-title {
                display: flex;
                justify-content: space-around;
                color: #333;
                margin-bottom: 30px;

                .be-title-left {
                    display: flex;
                    justify-content: start;
                }

                .title-text {
                    display: block;
                    font-size: 34px;
                    display: flex;
                    justify-content: start;
                    align-items: center;
                    margin-left: 15px;
                    font-weight: 700;
                }

                .btn-close {
                    display: block;
                    width: 190px;
                    height: 60px;
                    border-radius: 10px;
                    font-size: 24px;
                    background: #8261FF;
                    color: #fff;
                    text-align: center;
                    line-height: 60px;
                    margin-left: 100px;

                    &:active {
                        transform: scale(1.1, 1.1);
                    }
                }

                .icon {
                    margin: 0
                }

                .icon-gold-lock {
                    width: 40px;
                    height: 50px;
                    background: url("../../assets/images/callback/icon-gold.png") no-repeat;
                    background-size: 100% 100%;
                }

                .icon-copper-lock {
                    width: 40px;
                    height: 50px;
                    background: url("../../assets/images/callback/icon-copper.png") no-repeat;
                    background-size: 100% 100%;
                }

                .icon-siliver-lock {
                    width: 40px;
                    height: 50px;
                    background: url("../../assets/images/callback/icon-siliver.png") no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }
}

.wrapper {
    padding: 50px;

    .orders {
        .no-order {
            margin-top: 60px;
            .banner {
                width: 236px;
                height: 204px;
                background: url("~assets/images/orders/order-banner.png") no-repeat;
                background-size: 100% 100%;
                margin: 0 auto
            }

            .title {
                text-align: center;
                font-size: 44px;
                color: #000;
                margin: 60px 0 30px 0;
            }

            .caption {
                padding: 30px 50px;
                color: #A59BB3;
                font-size: 32px;
                line-height: 1.5;
                white-space: nowrap;
            }

            .btn-container {
                margin-top: 100px;
                width: 100%;
                height: 96px;

                .btn-submit {
                    display: block;
                    width: 670px;
                    height: 96px;
                    line-height: 96px;
                    text-align: center;
                    border-radius: 12px;
                    background: #189A63;
                    font-size: 32px;
                    margin: 0 auto;
                    color: #fff;

                    &.red {
                        background: #C5340B;
                    }
                }
            }
        }

        .order-element {
            width: 654px;
            background: #FFFFFF;
            box-shadow: 0px 22px 80px 0px rgba(0, 0, 0, 0.0800);
            border-radius: 16px;
            position: relative;
            margin-bottom: 50px;

            .wrapper-link {
                position: absolute;
                z-index: 999;
                width: 654px;
                height: 100%;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
            }

            &.valid {}

            &.invalid {
                .order-id {
                    color: #A59BB3;
                }

                .oi-element {
                    span.left {
                        color: #A59BB3;
                    }

                    span.right {
                        color: #A59BB3;
                    }
                }
            }

            .tag {
                position: absolute;
                top: 25px;
                right: 10px;
                width: 194px;
                height: 55px;
                border-radius: 10px;
                .order_state {
                    display: block;                    
                    height:50px;
                    line-height: 50px;
                    color: #fff;
                    font-size: 32px;                    
                    text-align: center;                    
                }

                &.invalid {
                    background: #c6c2e7;
                    background-size: 100% 100%;
                }

                &.valid {                    
                    background: #189A63;
                    background-size: 100% 100%;
                }
            }

            .order-id {
                padding: 30px 40px;
                border-bottom: 2px solid #EFEEF1;
                color: #189A63;
                font-size: 30px;
                height: 46px;
                line-height: 46px;
                text-align: left;
            }

            .order-info-list {
                padding: 30px;

                .oi-element {
                    overflow: hidden;
                    margin-bottom: 30px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    .left {
                        float: left;
                        color: #160544;
                        font-size: 32px;
                    }

                    .right {
                        float: right;
                        color: #160544;
                        font-size: 32px;
                    }
                }
            }
        }
    }
}
</style>